import { Component, input } from '@angular/core';
import { AbstractFormControl } from '../abstract-form-control';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { LabelDetailDto } from '@artemis-software/wr-api';
import CategoryEnum = LabelDetailDto.CategoryEnum;

@Component({
  standalone: false,
  selector: 'wr-label-category-select',
  templateUrl: './label-category-select.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: LabelCategorySelectComponent,
      multi: true,
    },
  ],
})
export class LabelCategorySelectComponent extends AbstractFormControl<CategoryEnum> {
  readonly values = Object.values(CategoryEnum).filter((value) => value !== CategoryEnum.None);

  readonly placeholder = input('Kategorie auswählen');
}
